import { AppState } from '@app-state/index';
import { ToastInputSettings } from '@custom-types/core/app-toast-notifications.model';
import { createSelector } from '@ngrx/store';

const selectToastNotifications = (state: AppState): ToastInputSettings => state.appToastNotifications;

export const appToastNotificationsSelector = createSelector(selectToastNotifications, (toastSettings) => toastSettings);
